require.config({
    paths   : {
        jquery : "jquery/jquery"
    },
    packages: [{
        name : "GameDayCore",
        location : "responsive-gameday-core/src/js"
    }]
});

define('../src/js/buildframe/kickstart',['require','exports','module','GameDayCore','jquery','responsive-gameday/bootstrap','extant/extant','responsive-gameday/helpers/EventDistributor','GameDayCore/GDModel/enums/events/EventTypes','GameDayCore/GDModel/enums/events/TrackingEvents','gameday-index-url-hasher/enums/HashEvents','gameday-index-url-hasher/UrlHasher','GameDayCore/GDUtil/window/Logg','requirejs-better-errors/requirejs-better-errors','message-service/message-service','GameDayCore/GDUtil/resources/GDConfig','Responsive/util/dom','responsive-gameday/views/Monitor/Events/SceneStateEvents','Responsive/controllers/VerticalViewController','Responsive/controllers/ScrollViewController','Responsive/controllers/CardViewController','responsive-gameday/controllers/VideoAdvertisingViewController','responsive-gameday/controllers/GamePanelStateViewController','responsive-gameday/controllers/PitchByPitchMatchupViewController','responsive-gameday/controllers/PitchFXViewController','responsive-gameday/controllers/WrapupPanelViewController','responsive-gameday/controllers/PregameViewController','responsive-gameday/controllers/LinescoreViewController','responsive-gameday/controllers/ColorViewController','responsive-gameday/helpers/JingleAssistant','responsive-pitch-fx/responsive-pitch-fx','responsive-gameday/controllers/GameStateViewController','../../../src/js/rules','image-monitor/image-monitor'],function (require, exports, module) {
    var GDC = require("GameDayCore"),
        $ = require('jquery'),
        responsiveGamedayBootstrap = require('responsive-gameday/bootstrap'),
        exists = require('extant/extant'),
        GDEventDistributor = require('responsive-gameday/helpers/EventDistributor'),
        eventEnums = require('GameDayCore/GDModel/enums/events/EventTypes'),
        trackingEvents = require('GameDayCore/GDModel/enums/events/TrackingEvents'),
        HashEvents = require('gameday-index-url-hasher/enums/HashEvents'),
        UrlHasher = require('gameday-index-url-hasher/UrlHasher'),
        logg = require('GameDayCore/GDUtil/window/Logg'),
        errorHelper  = require("requirejs-better-errors/requirejs-better-errors"),
        MessageService = require('message-service/message-service'),
        GDConfig = require("GameDayCore/GDUtil/resources/GDConfig"),
        dom = require("Responsive/util/dom"),
        scenes = require("responsive-gameday/views/Monitor/Events/SceneStateEvents");

    //Responsive controllers
    var VerticalViewController = require('Responsive/controllers/VerticalViewController'),
        ScrollViewController = require('Responsive/controllers/ScrollViewController'),
        CardViewController = require('Responsive/controllers/CardViewController'),
        VideoAdvertisingViewController = require("responsive-gameday/controllers/VideoAdvertisingViewController"),
        GamePanelStateViewController = require("responsive-gameday/controllers/GamePanelStateViewController"),
        PitchByPitchMatchupViewController = require("responsive-gameday/controllers/PitchByPitchMatchupViewController"),
        PitchFXViewController = require("responsive-gameday/controllers/PitchFXViewController"),
        WrapupPanelViewController = require('responsive-gameday/controllers/WrapupPanelViewController'),
        PregameViewController = require('responsive-gameday/controllers/PregameViewController'),
        LinescoreViewController = require("responsive-gameday/controllers/LinescoreViewController"),
        ColorViewController = require("responsive-gameday/controllers/ColorViewController"),
        JingleAssistant = require("responsive-gameday/helpers/JingleAssistant"),
        PitchFx = require("responsive-pitch-fx/responsive-pitch-fx");

    //Gameday controllers
    var GameStateViewController = require('responsive-gameday/controllers/GameStateViewController');
    
    
    //Gameday controllers
    var GamedayBusinessRules = require('../../../src/js/rules');
    
    //Responsive
    var win = window,
        doc = document,
        gdAppRoot = "gdLiveApp";

    var build_number = typeof BUILD_NUMBER !== "undefined" ? BUILD_NUMBER : "DEV",
        build_target = typeof BUILD_TARGET !== "undefined" ? BUILD_TARGET : '';

    window.GDC = GDC;
    $.extend(GDConfig, {
        build: {
            number: build_number,
            target: build_target
        },
        videoAdsEnabled: true,
        videoInColorFeed: true
    });

    win.onerror = function (msg, url, line, char, err) {
        logg.error('Unhandled exception', err || new Error(msg, url, line));
        return true;
    };

    $(function () {
        /* Safari 7.0.3 shuts down wheel propigation to iframes without a explicit handler */
        window.onmousewheel = function () {return true};
        if (window.frameElement) {
            try {
                window.frameElement.onmousewheel = window.onmousewheel;
            } catch (e) {
                logg.error('x-domain frame action');
            }
        }
    });

    ScrollViewController.setScrollOpts({
        scrollbars : true,
        hideScrollbars : false,
        fadeScrollbars : false,
        ineractiveScrollbars : true,
        autoHideScrollbars : false
    });

    responsiveGamedayBootstrap(function () {
        logg.log('kick kick');
        var evtDist = new GDEventDistributor(),
            trackingModuleContext,
            trackingModule;

        // if (window.parent) {
        //     try {
        //         trackingModule = window.parent.bam.tracking.track;
        //         trackingModuleContext = window.parent.bam.tracking;
        //     } catch (err) {
        //         logg.warn("can't inherit tracking module from parent");
        //     }
        // }
        // if (!exists(trackingModule)) {
        //     trackingModule = function (params) {
        //         logg.info("tracking handler", params && params.async && params.async.compActivity, params);
        //     }
        //     trackingModuleContext=this;
        // }
        // 
        
        // add an event listener to build a hash of view elelemts
        MessageService.addListener("registerViewComponent", registerViewComponents);
        MessageService.addListener("unregisterViewComponent", unregisterViewComponents);

        // Event listener that updates game state on root view for Pregame/Wrap
        MessageService.addListener(HashEvents.GAME_STATE_CHANGED, function(value) {
            setGameStateOnGDLiveAppContainer(value);
        });


        function VerticalGame(){
            VerticalGame.superclass.constructor.call(this);
        }
        VerticalViewController.spawn(VerticalGame).define({
            viewWillAppear : function(){
                var chyron = new LinescoreViewController("full"),
                    fullscreen_pbpvc = new PitchFXViewController({
                        allowControls: false,
                        canScroll: false
                    }),
                    vertical_live = new VerticalViewController(),
                    videoAds = new VideoAdvertisingViewController({
                        closeable: false,
                        view: this,
                        fullscreen : false
                    }),

                    rightCardTabs = new GamePanelStateViewController({
                        preload: false,
                        title: "RightTabs",
                        canScroll: false,
                        isLive: false,
                        playerCards : {
                            dock : 'right'
                        }
                    }),

                    leftCardTabs = new PitchByPitchMatchupViewController('card'),

                    leftPanel = new CardViewController("left", leftCardTabs, false),
                    rightPanel = new CardViewController("right", rightCardTabs, false);

                // fullscreen_pbpvc.setClassName('gamedayui-fullscreen');
                this.playLiveLookin = function (cid, gid) {
                    MessageService.publish("playLiveLookin", { contentID: cid, gameID: gid });
                };

                this.vertical_live = vertical_live;
                this.vertical_live.addChildController("fullscreen_pitchByPitch", fullscreen_pbpvc, "628px")
                    .addChildController("leftCard", leftPanel, "0%")
                    .addChildController("rightCard", rightPanel, "0%");

                this.addChildController("vertical_game", this.vertical_live, "628px")
                    .addChildController("chyron", chyron, "90px");

                VerticalGame.superclass.viewWillAppear.call(this);
                setTimeout(function () {
                    rightPanel.openTab();
                    leftPanel.openTab();
                }, 1500)

                fullscreen_pbpvc.setClassName('gamedayui-fullscreen');

                // // trigger the side panels to register, as they seem to need extra time to instantiate
                // leftPanel.register();
                // rightPanel.register();
            }
        });
        // establish view components
        var viewComponents = { },
            gdApp = new GameStateViewController({
                allowControls: false,
                canScroll: false,
                stateViews : {
                    pregame: PregameViewController,
                    live : VerticalGame,
                    wrapup : WrapupPanelViewController,
                    "default" : PregameViewController
                }
            }),
            root = gdApp;



        JingleAssistant.init(evtDist.events.PLAY_JINGLE);


        // vertical.addSizeHandler(function () {
        //     // fullscreen_pbpvc.setClassName('gamedayui-fullscreen');
        // }, 0, 1000000);

        PitchFx.config({
            batterScaling: true,
            base_width: 1158,
            base_height: 736,
            tiltShift : false,
            domBalls : false
        });

        CardViewController.setSwipe(true);
        // Overriding by for android build.
        //Responsive.vendor.useTransition=false;
        root.setOverlayConfig({
            splash: true,
            speed: 500,
            delay : 500
        });

        /* hide dead images */
        require('image-monitor/image-monitor')(true);
        // require('responsive-gameday/views/eggs/speak');
        root.setRootView(doc.getElementById(gdAppRoot), {
            autoHeight: 0,
            fixedHeight: 718
        });
        MessageService.on(HashEvents.GAME_ID_CHANGED,function(){
            root.showOverlay();
            MessageService.one.call(root,'init_data_loaded',root.hideOverlay);
        })
        // /* Start listening to tracking events after the initial view bootstrap is over */
        // MessageService.addListener.call(trackingModuleContext,trackingEvents.TRACKING, trackingModule);

        window.rootView = root;


        /**
         * Event handler functions to build and maintain an easy view stack reference by name.
         * @param payload should be the object registering itself
         * @param evt string == "registerComponent";
         */
        function registerViewComponents(payload, evt) {
            logg.log("recieved reference to " + payload.referenceName);
            viewComponents[payload.referenceName] = payload;

            // add event subscriptions based on the view component just registered...
            evtDist.addSubscribtions(eventsByViewComponentName(payload));
        }

        function unregisterViewComponents(payload, evt) {
            logg.log("removing reference to " + payload.referenceName);
            viewComponents[payload.referenceName] = null;

            // remmove subscriptions from unregstered components
            evtDist.removeSubscribtions(eventsByViewComponentName(payload));
        }

        function requestScoreboardAds() {
            // this is important!
            try { 
                parent.window.postMessage("getScoreboardAds", "http://" + doc.location.host); 
            } catch (err) { 
                logg.log("parent.window.postMessage has failed."); 
            }
        }

        // Work of updating the data attribute used by Pregame/Wrap
        function setGameStateOnGDLiveAppContainer(gameState) {
            // Set gamestate on gdAppLive container
            doc.getElementById(gdAppRoot).setAttribute("data-game-state", gameState.toLowerCase());
        }


        /**
         * MAP SCENE EVENTS IN THE GAME TO VIEW EVENTS
         * ATTACH HANDLERS TO THE VIEW EVENTS
         */
        evtDist.transportGameSceneEvents([
            { incoming: scenes.COMMERCIAL_BREAK_BEGIN, outgoing: evtDist.events.HIDE_MATCHUPS_CONTAINER },
            { incoming: scenes.MID_INNING, outgoing: evtDist.events.INITIATE_VIDEO_AD },
            { incoming: scenes.NEW_HALF_INNING, outgoing: evtDist.events.SHOW_MATCHUPS_CONTAINER },
            { incoming: scenes.COMMERCIAL_BREAK_END, outgoing: evtDist.events.CLOSE_VIDEO_AD },
            { incoming: scenes.COMMERCIAL_BREAK_END, outgoing: evtDist.events.SHOW_MATCHUPS_CONTAINER },
            { incoming: scenes.NEW_HALF_INNING, outgoing: evtDist.events.CLOSE_VIDEO_AD }
        ]);

        evtDist.transportUserEvents([
            { incoming: "playLiveLookin", outgoing: evtDist.events.OPEN_VIDEOS_VIEW },
            { incoming: HashEvents.SELECTED_TAB_CHANGED, outgoing: evtDist.events.CHANGE_TAB_VIEW }
        ]);

        evtDist.transportWindowEvents([
            { incoming: "notifyAdsRefreshed", outgoing: evtDist.events.GD_PAGE_ADS_UPDATED },
            { incoming: "updateChyronAds", outgoing: evtDist.events.UPDATE_CHYRON_ADS }
        ]);

        // register events by view component as they come in.
        function eventsByViewComponentName(component) {
            switch (component.referenceName) {
                case 'leftPanel':
                    return [
                        { scope: component, event: evtDist.events.HIDE_MATCHUPS_CONTAINER, handler: component.hide },
                        { scope: component, event: evtDist.events.SHOW_MATCHUPS_CONTAINER, handler: component.show }
                    ];
                    break;

                case 'rightPanel':
                    return [
                        { event: evtDist.events.OPEN_VIDEOS_VIEW, handler: component.openTab },
                        { event: evtDist.events.OPEN_PLAYER_CARD, handler: component.openTab }
                    ];
                    break;

                case 'RightTabs':
                    return [
                        { event: evtDist.events.CHANGE_TAB_VIEW, handler: component.setTabView, scope : component }
                    ];
                    break;

                case 'videos':
                    return [
                        { event: evtDist.events.OPEN_VIDEOS_VIEW, handler: component.playVideo }
                    ];
                    break;

                case 'boxscore':
                    return [ ];
                    break;

                case 'linescore':
                    return [
                        { event: evtDist.events.PLAY_JINGLE, handler: component.playJingle },
                        { event: evtDist.events.UPDATE_CHYRON_ADS, handler: component.updateAds }
                    ];
                    break;

                case 'videoAds':
                    return [
                        { event: evtDist.events.CLOSE_VIDEO_AD, handler: component.deactivate },
                        { event: evtDist.events.INITIATE_VIDEO_AD, handler: component.activate }
                    ];
                    break;

                default:
                    return [ ]; // For now, register nothing, but we may want a catch all at some point?
                    break;
            }
        }

        // this might be removable...
        evtDist.addSubscribtions([
            { event: evtDist.events.GD_PAGE_ADS_UPDATED, handler: requestScoreboardAds }
        ]);
        if (exists(viewComponents["linescore"])) { MessageService.publish("gdPageAdsUpdated");}

        rootView.viewComponents = viewComponents;

        // Let's give a view of the field before sliding in panels

        // Set gamestate on gdAppLive container
        setGameStateOnGDLiveAppContainer(GDC.getHashParams().game_state);

        if (exists(GDConfig.initProps.liveLookin)) {
            var cid = GDConfig.initProps.liveLookin;
            setTimeout(function () { MessageService.publish("playLiveLookin", { contentID: cid }) }, 3000);
        }
    });
});

